import { Text } from '@noorden-insurtech/alba-design-system';
import { AlertTriangle, X } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  onClose?: () => void;
}

export function ErrorMessage({ message, onClose }: ErrorMessageProps) {
  return (
    <div
      className='flex items-center gap-2 rounded-lg p-3 border w-full'
      style={{ background: '#F4636333', borderColor: '#F46363' }}
      role='alert'
      aria-live='assertive'
    >
      <AlertTriangle
        size={18}
        color={'#F46363'}
        aria-hidden='true'
        className='flex-shrink-0'
      />
      <div className='flex-1'>
        <Text size='sm' className='text-[#2C2864] whitespace-pre-line'>
          {message}
        </Text>
      </div>
      {onClose && (
        <button
          type='button'
          aria-label='Fechar alerta'
          onClick={onClose}
          className='shrink-0 hover:opacity-80'
        >
          <X size={18} color={'#2C2864'} />
        </button>
      )}
    </div>
  );
}
